import { render, staticRenderFns } from "./faren.vue?vue&type=template&id=a9c5cc7a&scoped=true&"
import script from "./faren.vue?vue&type=script&lang=js&"
export * from "./faren.vue?vue&type=script&lang=js&"
import style0 from "./faren.vue?vue&type=style&index=0&id=a9c5cc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c5cc7a",
  null
  
)

export default component.exports